import { Component, OnInit } from "@angular/core";
import { UsersService } from "../services/users/users.service";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";

@Component({
    selector: "app-my-tickets",
    templateUrl: "./my-tickets.component.html",
    styleUrls: ["./my-tickets.component.scss"],
})
export class MyTicketsComponent implements OnInit {
    internalTickets: any[] = [];
    externalTickets: any[] = [];
    loading = false;
    messageInternal: string | null = null;
    messageExternal: string | null = null;

    constructor(
        private usersService: UsersService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.loadItems();
    }

    loadItems(): void {
        this.loading = true;
        this.internalTickets = [];
        this.externalTickets = [];
        this.messageInternal = null;
        this.messageExternal = null;

        // Call both APIs in parallel using forkJoin
        forkJoin({
            internal: this.usersService.getMyTickets(),
            external: this.usersService.getExternalTickets(),
        }).subscribe({
            next: (result) => {
                const minDate = new Date("2021-01-01T22:00:00.512Z");

                // Process internal tickets
                (result.internal || []).forEach((ticket) => {
                    // const d = new Date(ticket.date);
                    // if (d.getTime() >= minDate.getTime()) {
                        this.internalTickets.push(ticket);
                    // }
                });
                // console.log("result", result);
                // Process external tickets
                (result.external || []).forEach((ticket) => {
                    // const d = new Date(ticket.date);
                    // if (d.getTime() >= minDate.getTime()) {
                        this.externalTickets.push(ticket);
                    // }
                });

                // Sort both arrays by date (newest first)
                this.internalTickets.sort(
                    (a, b) =>
                        new Date(b.date).getTime() - new Date(a.date).getTime(),
                );
                this.externalTickets.sort(
                    (a, b) =>
                        new Date(b.date).getTime() - new Date(a.date).getTime(),
                );

                // Set messages if no tickets found
                if (!this.internalTickets.length) {
                    this.messageInternal =
                        "Nu aveți bilete de trimitere interne.";
                }
                if (!this.externalTickets.length) {
                    this.messageExternal =
                        "Nu aveți bilete de trimitere externe.";
                }

                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.messageInternal =
                    "A apărut o eroare la încărcarea biletelor.";
                this.messageExternal =
                    "A apărut o eroare la încărcarea biletelor.";
            },
        });
    }

    addTicket(): void {
        this.router.navigate(["adauga-bilet"]);
    }
}
